export default {
  title: 'Company where user belong to',
  message: `The companies shown below are those where you are listed as a user. To log in you must have the corresponding certificate for each user. When you click on the icon, the application will disconnect and you will be directed back to the log-in.`,
  table: {
    username: 'Username',
    company: 'Company',
    logout: 'Log in'
  }
}
